import { Node } from 'ts-morph'

export function getTemplateReplacement(node: Node, literalText: string): string {
  if (Node.isTemplateHead(node)) {
    return `\`${literalText}\${`
  }

  if (Node.isTemplateMiddle(node)) {
    return `}${literalText}\${`
  }

  return `}${literalText}\``
}
